import { useEffect, useRef } from 'react';
import { relewiseMappingService } from '../MappingService';
import { relewiseTrackingService } from '../TrackingService';

export const useProductViewTracker = (itemId: string | undefined, isSingleSize: boolean) => {
    if (typeof window === 'undefined') {
        return;
    }

    const hasTrackedMasterProductRef = useRef(false);
    const lastTrackedVariantRef = useRef<string | undefined>();
    const search = window.location.search ?? '';

    useEffect(() => {
        if (!itemId) {
            return;
        }

        const params = new URLSearchParams(search);
        const color = params.get('color');
        const size = params.get('size');
        const hasVariant = !!color && !!size;

        if (hasVariant) {
            const relewiseVariantId = relewiseMappingService.mapProductDimensionsToRelewiseVariantId(itemId, color, size);
            if (relewiseVariantId !== lastTrackedVariantRef.current) {
                relewiseTrackingService.trackProductView(relewiseMappingService.prefixId(itemId), relewiseVariantId);
            }
            lastTrackedVariantRef.current = relewiseVariantId;
        }
        if (!hasVariant && !hasTrackedMasterProductRef.current && !isSingleSize) {
            relewiseTrackingService.trackProductView(relewiseMappingService.prefixId(itemId));
        }
        hasTrackedMasterProductRef.current = true;
    }, [itemId, search]);
};
